import React, { useState } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Box,
  Text,
  Badge,
  Button,
  HStack,
  IconButton,
  Flex,
  Spacer,
} from "@chakra-ui/react";
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa6'
const ExtensionHistoryTable = ({ extensionHistory }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  // Función para formatear la fecha
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES');
  };
  // Si no hay datos de historial, mostrar un mensaje
  if (!extensionHistory || extensionHistory.length === 0) {
    return (
      <Box p={4} textAlign="center">
        <Text color="gray.500">No hay historial de prorrogas disponible</Text>
      </Box>
    );
  }
  // Calcular paginación
  const totalPages = Math.ceil(extensionHistory.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentItems = extensionHistory.slice(startIndex, endIndex);
  // Funciones de navegación
  const goToNextPage = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };
  const goToPreviousPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };
  const goToPage = (page) => {
    setCurrentPage(page);
  };
  return (
    <Box mb={4}>
      <Flex mb={3} align="center">
        <Text fontSize="lg" fontWeight="bold">
          Historial de Prorrogas
        </Text>
        <Spacer />
        <Text fontSize="sm" color="gray.500">
          {extensionHistory.length} registro{extensionHistory.length !== 1 ? 's' : ''} total{extensionHistory.length !== 1 ? 'es' : ''}
        </Text>
      </Flex>
      
      <TableContainer>
        <Table variant="simple" size="sm">
          <Thead>
            <Tr>
              <Th>N°</Th>
              <Th>Días Ext.</Th>
              <Th>Fecha Ant.</Th>
              <Th>Nueva Fecha</Th>
              <Th>Fecha Ext.</Th>
              <Th>Usuario</Th>
            </Tr>
          </Thead>
          <Tbody>
            {currentItems.map((extension) => (
              <Tr key={extension.id}>
                <Td>
                  <Badge colorScheme="blue" variant="outline">
                    {extension.extension_number}
                  </Badge>
                </Td>
                <Td>
                  <Text fontWeight="medium">
                    {extension.days_extended} días
                  </Text>
                </Td>
                <Td>{formatDate(extension.previous_expiration_date)}</Td>
                <Td>{formatDate(extension.new_expiration_date)}</Td>
                <Td>
                  <Text fontSize="sm">
                    {formatDate(extension.extension_date)}
                    <br />
                    <Text as="span" color="gray.500">
                      {extension.extension_time}
                    </Text>
                  </Text>
                </Td>
                <Td>
                  <Text fontSize="sm">
                    {extension.user?.nickname || '-'}
                    <br />
                    <Text as="span" color="gray.500" fontSize="xs">
                      {extension.user?.email || '-'}
                    </Text>
                  </Text>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
      {/* Controles de Paginación */}
      {totalPages > 1 && (
        <Flex mt={4} justify="center" align="center">
          <HStack spacing={2}>
            <IconButton
              icon={<FaChevronLeft />}
              onClick={goToPreviousPage}
              isDisabled={currentPage === 1}
              size="sm"
              variant="outline"
              aria-label="Página anterior"
            />
            
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <Button
                key={page}
                onClick={() => goToPage(page)}
                size="sm"
                variant={currentPage === page ? "solid" : "outline"}
                colorScheme={currentPage === page ? "blue" : "gray"}
              >
                {page}
              </Button>
            ))}
            
            <IconButton
              icon={<FaChevronRight />}
              onClick={goToNextPage}
              isDisabled={currentPage === totalPages}
              size="sm"
              variant="outline"
              aria-label="Página siguiente"
            />
          </HStack>
        </Flex>
      )}
      
      {/* Información de paginación */}
      {totalPages > 1 && (
        <Text textAlign="center" mt={2} fontSize="sm" color="gray.500">
          Mostrando {startIndex + 1}-{Math.min(endIndex, extensionHistory.length)} de {extensionHistory.length} registros
        </Text>
      )}
    </Box>
  );
};
export default ExtensionHistoryTable;